import { PureKnockoutView } from '@bingads-webui/knockout-view';
import tmpl from './template.pug';
import ViewModel from './viewmodel';

export class TrackingTemplateView extends PureKnockoutView {
  /**
   * Initilize tracking template view settings
   *
   * @param {Object} param - An object containing these default options for view:
   * @param {Object} param.i18n - the localization settings
   * @param {Object} param.i18n.getString - localization settings function
   * @param {boolean} param.editMode - whether the view is in edit mode, default true
   * @param {function} param.template - template for the view, by default using tmpl
   * @param {String} param.trackingTemplate - tracking template
   * @param {String[]} param.errorMessages - error messages to show
   * @returns {void} void
  */
  initialize({
    i18n,
    editMode = true,
    template = tmpl,
    trackingTemplate,
    showUurlTestTool = false,
  }) {
    this.options = {
      i18n,
      editMode,
      trackingTemplate,
      template,
      showUurlTestTool,
    };

    super.initialize(this.options);

    this.viewModel.trackingTemplate.subscribe(() => {
      this.trigger('trackingTemplate:updated', { isValid: this.isValid(), trackingTemplate: this.getTrackingTemplate() });
    }, this);
  }

  get template() {
    return () => this.options.template({ i18n: this.options.i18n });
  }

  get ViewModel() {
    return ViewModel;
  }

  /**
   * Set edit mode
   * @param {boolean} isEdit - whether to set to edit (false to be read mode)
   *
   * @returns {void} void
  */
  setEditMode(isEdit) {
    this.viewModel.editMode(isEdit);
  }

  /**
   * Set tracking template
   * @param {String} trackingTemplate - new values to set
   *
   * @returns {void} void
  */
  setTrackingTemplate(trackingTemplate) {
    this.viewModel.trackingTemplate(trackingTemplate);
  }

  /**
   * Get tracking template
   *
   * @returns {String} tracking template
  */
  getTrackingTemplate() {
    return (this.viewModel.trackingTemplate() || '').trim(); // handle the space
  }

  setErrors(errors) {
    this.viewModel.errorMessages(errors);
  }

  isValid() {
    return this.viewModel.isValid();
  }
}

